import { EPNodeFieldsResolvers } from '../5-node/fields';
const EPDiagramNodeFieldsResolver = {
    async refQuestions(node, context) {
        // For offline, return empty array
        return [];
    }
};
export const epDiagramFieldsResolvers = {
    EPDiagram: {
        ...EPNodeFieldsResolvers,
        ...EPDiagramNodeFieldsResolver,
    },
};
